import React, {useState} from "react";
import QR from "../assets/images/img.png"
import tether from "../assets/images/tether.png"
import Icon from "../components/ui/Icon";
import FAQ from "../components/payment/FAQ";
import Tip from "../components/payment/Tip";

const Home = () => {

    const [qrCode, setQrCode] = useState(false);

    const showImageHandler = () => {
        setQrCode(prevState => !prevState);
    }
    return (
        <>
            <h4 className="text-center fw-semibold mb-3 mb-sm-5 mt-0 mt-sm-4 mt-md-6">Payment Method</h4>
            <div className="mb-md-9 mb-2">
                <label className="form-label fw-semibold lft-border fs-md d-md-block d-none">
                    <span className="ms-2">코인을 선택해주세요.</span>
                </label>
                <select className="form-select form-select-lg form-select-image mb-4 mb-sm-7  fs-lg fw-bold" aria-label="Large select example"
                    style={{backgroundImage: `url(${tether}), var(--bs-form-select-bg-img)`}}
                >
                    <option defaultValue="0">USDT On Tron</option>
                    <option value="2">USDT On BSC</option>
                </select>
                <label className="form-label fw-semibold lft-border fs-md d-md-block d-none">
                    <span className="ms-2">입금주소 생성 QR</span>
                </label>
                <div className="card p-5 bg-blue-lighter bg-sm">
                    <div className="d-md-flex d-block">
                        <div className="me-md-5 m-0 text-center">
                            <div className="QR-img">
                                {qrCode ?
                                    <img src={QR} alt="qr_code" className="border p-3 rounded-2 h-100 w-100 mx-auto d-block"/> :
                                    <button className="btn btn-primary me-md-5 text-white p-3 w-100 mx-md-auto" onClick={showImageHandler}>Click to view QR code</button>}
                            </div>
                        </div>
                        {/*Transaction type & detailed section*/}
                        <div className="w-100">
                            <label className="form-label fw-semibold fs-md d-md-block d-none">BitCoin 입금 주소</label>
                            <select className="form-select form-select-lg mb-3 d-md-block d-none fw-bolder text-secondary"
                                    aria-label="Large select example">
                                <option defaultValue="0">TLWrJuvjb2WF3En4WxvZyx8dv5repBSAJS</option>
                                <option value="1">TQcfth9zpgSC4BB9QhU1zFmTHSFUakgipb</option>
                            </select>
                            <button type="button"
                                    className="btn bg-blue-light text-primary btn-sm d-block ms-auto border rounded-2 fs-md p-2 bg-opacity-25 d-md-block d-none">
                                <Icon name="copy" width="25" height="16" fill="white" className="me-1"/>
                                Copy
                            </button>

                        </div>
                    </div>

                    {/*Horizontal line*/}
                    <hr className="my-6 d-md-block d-none"/>

                    {/*Detailed Section*/}
                    <div className="d-md-block d-none">
                        <div className="d-none d-md-flex justify-content-between align-items-center mb-2">
                            <label className="form-label fw-semibold fs-md mb-0">Minimum deposit amount</label>
                            <p className="fs-md mb-0">0.0012 USDT On Tron</p>
                        </div>
                        <div className="d-none d-md-flex justify-content-between align-items-center mb-2">
                            <label className="form-label fw-semibold fs-md mb-0">Transfer to</label>
                            <p className="fs-md mb-0">Spot account</p>
                        </div>
                        <div className="d-none d-md-flex justify-content-between align-items-center mb-2">
                            <label className="form-label fw-semibold fs-md mb-0">Contract address</label>
                            <p className="fs-md mb-0">****97955</p>
                        </div>
                        <div className="d-none d-md-flex justify-content-between align-items-center mb-2">
                            <label className="form-label fw-semibold fs-md mb-0">Deposit confirmation</label>
                            <p className="fs-md mb-0">15nework confirmations</p>
                        </div>
                        <div className="d-none d-md-flex justify-content-between align-items-center mb-2">
                            <label className="form-label fw-semibold fs-md mb-0">Withdrawal unlocking</label>
                            <p className="fs-md mb-0">15nework confirmations</p>
                        </div>
                    </div>
                </div>


                {/*Transaction Id shown on mobile screen*/}
                <div className="input-group my-4 my-sm-7 d-inline-flex d-md-none">
                    <input type="text" className="form-control p-3 fs-md" placeholder="TLWrJuvjb2WF3En4WxvZyx8dv5repBSAJS"
                           aria-label="Recipient's username" aria-describedby="button-addon2"/>
                    <button className="btn border bg-blue-light" type="button" id="button-addon2">
                        <Icon name="copy" width="25" height="16" fill="white" className="me-1"/>
                    </button>
                </div>
            </div>

            {/*Form Section*/}
            <form className="custom-form">
                {/*Heading*/}
                <h5 className="text-center mb-3 mb-sm-5 mt-0 mt-sm-4 mt-lg-8  fw-semibold">코인 입금하기</h5>
                <div className="card p-5 bg-blue-lighter bg-card-sm">
                    {/*Section Heading*/}
                    <div
                        className="justify-content-between align-items-center border-bottom pb-3 mb-6 d-md-flex d-none">
                        <label className="form-label fw-semibold fs-md">신청 입금금액(￦)</label>
                        <h3><span className="text-primary fs-1">1,000,000</span><span className="fs-md fw-semibold">원</span>
                        </h3>
                    </div>

                    {/*This heading section is displayed on small screen*/}
                    <div className="d-block d-md-none border rounded-2 bg-blue-light p-2 text-center mb-4 mb-sm-7">
                        <label className="form-label fw-semibold fs-xs">신청 입금금액(￦)</label>
                        <h1 className="mb-0"><span className="text-primary">1,000,000</span><span className="fs-md fw-semibold">원</span>
                        </h1>
                    </div>

                    {/*Label and inputs*/}
                    <div className="mb-3 mb-sm-5 d-flex d-sm-block form-item">
                        <label htmlFor="input1" className="form-label fs-md fw-semibold">현재 시세 - 1 USDT (1초 갱신)</label>
                        <input type="text" id="input1" className="form-control fs-lg fw-regular" defaultValue="1491 KRW"/>
                    </div>

                    <div className="mb-3 mb-sm-5 d-flex d-sm-block form-item">
                        <label htmlFor="input2" className="form-label fs-md fw-semibold">테더 입금주소</label>
                        <input type="text" id="input2" className="form-control fs-lg fw-regular"
                               defaultValue="업비트 - vdb912sgss12"/>
                    </div>

                    <div className="mb-3 mb-sm-5 d-flex d-sm-block form-item">
                        <label htmlFor="input3" className="form-label fs-md fw-semibold">테더 입금수량</label>
                        <input type="text" id="input3" className="form-control fs-lg fw-regular" defaultValue="671 USDT"/>
                    </div>

                    <div className="mb-3 mb-sm-5 d-flex d-sm-block form-item">
                        <label htmlFor="input4" className="form-label fs-md fw-semibold">보내는 거래소명</label>
                        <input type="text" id="input4" className="form-control fs-lg fw-regular" placeholder="ex) 업비트"/>
                    </div>

                    <div className="mb-3 mb-sm-5 d-flex d-sm-block form-item">
                        <label htmlFor="input5" className="form-label fs-md fw-semibold">보내는 테더 주소</label>
                        <input type="text" id="input5" className="form-control fs-lg fw-regular" placeholder="테더 주소"/>
                    </div>
                </div>

                {/*Submission button*/}
                <button type="button"
                        className="btn-big btn btn-primary btn-lg rounded-pill d-flex mx-auto align-items-center text-white fw-semibold btn-trans my-2 my-sm-4 my-md-7 ">
                    테더 입금하기
                    <Icon name="right-arrow" width="25" height="36" fill="black" className="ms-2"/>
                </button>
            </form>

            {/*Tip Section*/}
            <div className="mb-8">
                <div className="d-flex align-items-center">
                    <Icon name="bulb" width="35" height="36"/>
                    <h6 className="fs-md fw-semibold mb-0">Tip!</h6>
                </div>
                <div className="card p-6 bg-blue-lighter">
                    {/*Common component for TIP*/}
                    <Tip/>
                </div>
            </div>

            {/*FAQ Section*/}
            <div>
                <div className="d-flex align-items-center">
                    <Icon name="bulb" width="35" height="36"/>
                    <h6 className="fs-md fw-semibold mb-0">FAQ!</h6>
                </div>
                <div className="card p-6 bg-blue-lighter">
                    {/*Common component for FAQ*/}
                    <FAQ/>
                    <FAQ/>
                    <FAQ/>
                </div>
            </div>
        </>
    );
}
export default Home;
